import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDeleteBranch = () => {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const displacementOrigin = ({ branchGuid }, onUpdate) => {
    setLoading(true);

    axiosClient
      .delete(`Product/Branch/Delete?GUID=${branchGuid}`)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar('برنچ با موفقیت حذف شد', { variant: 'success' });
          onUpdate();
        } else {
          enqueueSnackbar(res?.message || 'خطا در حذف برنچ', {
            variant: 'error',
          });
        }
      })
      .catch(err =>
        enqueueSnackbar(err?.message || 'خطا در حذف برنچ', {
          variant: 'error',
        }),
      )
      .finally(() => setLoading(false));
  };

  return [displacementOrigin, loading];
};

export default useDeleteBranch;
